module.exports = __webpack_public_path__ + "media/components/country-flag/static/xk-45aadbeb641ca09eeffcd8a33a247e4d.svg";